import { createFileRoute, notFound } from '@tanstack/react-router';
import { requireSkillsFeature } from '@/features/resources/guard';
import { PeopleSkillsPage } from '@/features/resources/skills/people-skills-page';
import { parsePeopleSkillsSearch } from '@/features/resources/skills/people-skills-search';

/** RES-16 "Wer kann was?" for every internal user (externals: not found). */
export const Route = createFileRoute('/_app/skills')({
  validateSearch: (raw: Record<string, unknown>) => parsePeopleSkillsSearch(raw),
  beforeLoad: async ({ context }) => {
    if (context.me.user.userType !== 'internal') throw notFound();
    await requireSkillsFeature(context.queryClient);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PeopleSkillsPage
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: next, replace: true });
      }}
    />
  );
}
